import React, { FC } from 'react'
import {
	Control,
	FieldErrors,
	FieldPath,
	UseFormSetValue
} from 'react-hook-form'

import { Button, DragAndDrop, Loader, TextArea, TextInput } from 'UI'
import { AcceptTypes, SizeTypes } from 'UI/DragAndDrop/types'
import { ButtonStyles } from 'UI/Button/types'
import { MainFormTabState } from 'containers/Courses/Entities/Lessons/Tabs/Content/MainForm'

import { ILesson } from 'types/models/lesson.model'
import cl from '../style.module.scss'

interface MainFormTabProps {
	errors: FieldErrors<MainFormTabState>
	onChange: (name: FieldPath<MainFormTabState>) => (value: any) => void
	onSubmit: () => void
	control: Control<MainFormTabState>
	mediaFilesInfo: ILesson['mediaFilesInfo']
	docsFilesInfo: ILesson['docsFilesInfo']
	onOpenCanceledChange: () => void
	setValue: UseFormSetValue<MainFormTabState>
	isLoading: boolean
}

const MainFormTab: FC<MainFormTabProps> = ({
	errors,
	onChange,
	control,
	onSubmit,
	mediaFilesInfo,
	docsFilesInfo,
	onOpenCanceledChange,
	setValue,
	isLoading
}) => (
	<div className={cl.container}>
		<div className={cl.header}>
			<span>Здесь вы можете указать информацию по уроку.</span>
		</div>
		<form noValidate onSubmit={onSubmit} className={cl.form}>
			<div className={cl.inputs}>
				<div className={cl.inputContainer}>
					<label htmlFor="name">Название *</label>
					<p className={cl.caption}>
						Добавьте название урока и ученикам будет легче ориентироваться по
						материалам Курса.
					</p>
					<TextInput
						error={errors.name?.message}
						name="name"
						id="name"
						onChange={onChange('name')}
						control={control}
					/>
				</div>
				<div className={cl.inputContainer}>
					<label htmlFor="description">Информация</label>
					<TextArea
						error={errors.description?.message}
						name="description"
						id="description"
						onChange={onChange('description')}
						control={control}
					/>
				</div>
				<div className={cl.inputContainer}>
					<label htmlFor="mediaFiles">Загрузить видео или аудио файл</label>
					<DragAndDrop
						multiple
						singleFile
						name="mediaFiles"
						id="mediaFiles"
						control={control}
						onDelete={(removeTitleArray) =>
							setValue('mediaFilesInfoTitleList', removeTitleArray)
						}
						previewUrl={mediaFilesInfo}
						onChange={onChange('mediaFiles')}
						size={[3, SizeTypes.GB]}
						accept={[
							AcceptTypes.MKV,
							AcceptTypes.MP4,
							AcceptTypes.MP3,
							AcceptTypes.MPEG4,
							AcceptTypes.XM4A,
							AcceptTypes.WAV
						]}
					/>
				</div>
				<div className={cl.inputContainer}>
					<label htmlFor="docsFiles">Загрузить учебные материалы</label>
					<DragAndDrop
						multiple
						name="docsFiles"
						id="docsFiles"
						control={control}
						onDelete={(removeTitleArray) => {
							setValue('docsFilesInfoTitleList', removeTitleArray)
						}}
						previewUrl={docsFilesInfo}
						onChange={onChange('docsFiles')}
						size={[3, SizeTypes.GB]}
						accept={[
							AcceptTypes.DOC,
							AcceptTypes.DOCX,
							AcceptTypes.PDF,
							AcceptTypes.PPT,
							AcceptTypes.PPTX,
							AcceptTypes.TXT,
							AcceptTypes.XLS,
							AcceptTypes.XLSX
						]}
					/>
				</div>
				<div className={cl.splitLine} />
			</div>
			<div className={cl.buttons}>
				<Button
					onClick={onOpenCanceledChange}
					styleTypes={[ButtonStyles.OUTLINE_PRIMARY, ButtonStyles.ROUND]}
				>
					Отменить изменения
				</Button>
				<Button
					type="submit"
					styleTypes={[ButtonStyles.PRIMARY, ButtonStyles.ROUND]}
					disabled={isLoading}
				>
					{isLoading ? <Loader /> : 'Сохранить изменения'}
				</Button>
			</div>
		</form>
	</div>
)

export default MainFormTab
